import Image from '@/atoms/Image/Image';
import {StyledAdCard} from './styles';
import {AdCardComponentProps} from './typings';

const AdCard = ({card}: AdCardComponentProps) => {
  return (
    <StyledAdCard href={card.link}>
      <Image
        path={card.images[0]?.path}
        alt={card.image_alt ?? 'Ad card'}
        width={card.images[0]?.width}
        height={card.images[0]?.height}
        mainColor={card.average_colour ?? undefined}
        retina
        responsive
      />
    </StyledAdCard>
  );
};

export default AdCard;
